<div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
  <div class="row row-for-levels">
    <div class="col-md-3 text-align-left">
      <label for="firstName" class="margin-bottom-0px margin-top-5px"> {{field.Title}}</label>
    </div>
    <div class="col-md-4">
      <div *ngFor="let cc of field.ValueSource | splitpipe:','">
        <div>
          <label for="eventInput2"> {{cc}}</label>
          <input type="radio" class="form-control" value="{{cc}}" name="{{i}}"
                 [(ngModel)]="field.Value"
                 placeholder="Value" checked="checked">

        </div>


      </div>
      <!--<input class="form-control " [(ngModel)]="field.Value" type="text" [ngModelOptions]="{standalone: true}" />-->



    </div>

  </div>

</div>
